import styled from 'styled-components';

export default styled.div`
  background-color: white;
  border-radius: 4px;
  padding: 1em;
`;
